const Media = {

  /**
   * @return {void}
   */
  initialize: function () {
    this.setup();
  },

  /**
   * @return {void}
   */
  setup: () => {

    let sliders = document.querySelectorAll('.slider-media');
    if (sliders.length == 0) {
      return;
    }

    /**
     * Create slider interface on each slider class element
     * @return void
     */
    [...sliders].forEach(slider => {

      let items = slider.querySelectorAll('.slider-media-item');
      if (items.length == 0) {
        return;
      }

      /**
       * Reset all objects display to none
       * @return void
       */
      function reset() {
        slider.firstElementChild.style.marginLeft = '0';
      }

      let bullets = slider.querySelectorAll('.slider-media-bullet');
      if (bullets.length > 0) {
        /**
         * Add click event into bullets
         * @return void
         */
        [...bullets].forEach(bullet => {
          /**
           * @param {MouseEvent} e
           * @return void
           */
          bullet.addEventListener('click', (e) => {
            reset();
            setActive(e.target.getAttribute('index'));
          });
        });
      }

      /**
       * Displays only selected element
       * @param  {int} index
       * @return void
       */
      function setActive(index) {
        let element = items[index].parentElement.firstElementChild;
        if (typeof element === 'undefined') {
          return;
        }
        element.style.marginLeft = '-' + parseInt(index * 100) + '%';

        bullets.forEach((bullet) => {
          bullet.classList.remove('product-view-media-item__bullet--active');
        });
        bullets[index].classList.add("product-view-media-item__bullet--active");
      }

      /**
       * Add touch right or left swipe elements on mobile
       * @return void
       */

      let currentIndex = 0;
      let touchstartX = 0;
      let touchendX = 0;

      function checkDirection() {
        if (touchendX < touchstartX - 60) {
          let next = items[currentIndex + 1];
          if (typeof next !== 'undefined') {
            currentIndex++;
            reset();
            setActive(currentIndex);
          }
        }
        if (touchendX > touchstartX + 60) {
          let previous = items[currentIndex - 1];
          if (typeof previous !== 'undefined') {
            currentIndex--;
            reset();
            setActive(currentIndex);
          }
        }
      }

      slider.addEventListener('touchstart', e => {
        touchstartX = e.changedTouches[0].screenX;
      })

      slider.addEventListener('touchend', e => {
        touchendX = e.changedTouches[0].screenX
        checkDirection()
      })

    });
  },
};

export default Media;